import React from 'react'

type Title = {
  title: string
}

export default function AdminTitle({title}: Title) {
  return (
    <div className='admin-main-title'>{title}</div>
  );
}
